module.exports = __webpack_public_path__ + "static/media/preview.6cc5d792.png";